// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface GremlinResourcesListGremlinRoleAssignmentsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface GremlinResourcesDeleteGremlinRoleAssignmentOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface GremlinResourcesCreateUpdateGremlinRoleAssignmentOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface GremlinResourcesGetGremlinRoleAssignmentOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface GremlinResourcesListGremlinRoleDefinitionsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface GremlinResourcesDeleteGremlinRoleDefinitionOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface GremlinResourcesCreateUpdateGremlinRoleDefinitionOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface GremlinResourcesGetGremlinRoleDefinitionOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface GremlinResourcesRetrieveContinuousBackupInformationOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface GremlinResourcesListGremlinGraphsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface GremlinResourcesDeleteGremlinGraphOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface GremlinResourcesCreateUpdateGremlinGraphOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface GremlinResourcesGetGremlinGraphOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface GremlinResourcesListGremlinDatabasesOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface GremlinResourcesDeleteGremlinDatabaseOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface GremlinResourcesCreateUpdateGremlinDatabaseOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface GremlinResourcesGetGremlinDatabaseOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface GremlinResourcesMigrateGremlinGraphToManualThroughputOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface GremlinResourcesMigrateGremlinGraphToAutoscaleOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface GremlinResourcesUpdateGremlinGraphThroughputOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface GremlinResourcesGetGremlinGraphThroughputOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface GremlinResourcesMigrateGremlinDatabaseToManualThroughputOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface GremlinResourcesMigrateGremlinDatabaseToAutoscaleOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface GremlinResourcesUpdateGremlinDatabaseThroughputOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface GremlinResourcesGetGremlinDatabaseThroughputOptionalParams extends OperationOptions {}
